<template>
  <div>
    <button
      @click="toggleFollow"
      :class="[isFollowing ? 'bg-transpartent' : 'bg-primary-default']"
      class="flex justify-center py-2 px-2 md:px-4 border border-white shadow-sm text-sm font-medium text-white rounded-full hover:bg-primary-default/50 items-center mr-2"
    >
      <UserMinusIcon class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block" aria-hidden="true" v-if="isFollowing" />
      <UserPlusIcon class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block" aria-hidden="true" v-else />
      <span class="ml-1">{{ isFollowing ? 'Patiënt ontvolgen' : 'Patiënt volgen' }}</span>
    </button>
    <generic-modal v-if="showFollowModal">
      <template #header>
        Patiënt volgen
      </template>
      <template #body>
        <p>U staat op het punt om een patiënt te volgen. Door het volgen van een patiënt ontvangt u updates met betrekking tot zijn behandeling. Deze updates vindt u terug in de dashboard ‘Mijn patiënten’.</p>
      </template>
      <template #footer>
        <div class="modal-checkbox">
          <v-checkbox-group
            class="checkbox-group"
            label="Laat dit bericht niet meer zien"
            inputid="rememnerFollowPatient"
            @input="changeRememberFollowPatient(...arguments)"
          />
        </div>
        <v-button id="step2" tagelement="button" md primary @click="closeModal"> Ik begrijp het </v-button>
      </template>
    </generic-modal>
    <generic-modal v-if="showUnfollowModal" :has-close-button="true" @close="closeModal">
      <template #header>
       Patiënt ontvolgen
      </template>
      <template #body>
        <p>U staat op het punt om een patiënt te ontvolgen. Door het ontvolgen van een patiënt ontvangt u geen updates meer met betrekking tot zijn/haar behandeling. Weet u zeker dat u wilt doorgaan?"
	    </p>
      </template>
      <template #footer>
        <v-button tagelement="button" md hollow transparent @click="closeModal"> Annuleren </v-button>
        <v-button tagelement="button" md primary @click="toggleFollow01"> Patiënt toch ontvolgen </v-button>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import { mapActions, useStore } from 'vuex';
import { computed } from 'vue';
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup';
import GenericModal from '@/components/shared/GenericModal';
import { UserMinusIcon, UserPlusIcon } from '@heroicons/vue/20/solid';
export default {
  name: 'PatientFollow',
  components: {
    UserMinusIcon,
    UserPlusIcon,
    VCheckboxGroup,
    GenericModal
  },
  props: {
    isFollowing: {
      default: false,
      type: Boolean
    }
  },
  setup() {
    const store = useStore();

    const patientFollow = computed(() => store.getters['patient/getPatientFollow']);
    const setRememberPatientFollow = (value) => store.commit('patient/setRememberPatientFollow', value);

    return {
      patientFollow,
      setRememberPatientFollow,
      ...mapActions({
        set: 'patient/setPatientFollowStatus'
      })
    };
  },
  data() {
    return {
      showFollowModal: false,
      showUnfollowModal: false
    };
  },
  created() {
    const self = this;
  },
  methods: {
    closeModal() {
      this.showFollowModal = false;
      this.showUnfollowModal = false;
    },
    toggleFollow01() {
      const data = { Follow: !this.isFollowing };
      this.showUnfollowModal = false;
      this.set(data);
    },
    toggleFollow() {
      const data = { Follow: !this.isFollowing };
      if (!this.isFollowing) {
        if (!this.patientFollow) {
          this.showFollowModal = true;
        }
        this.set(data);
      } else {
        this.showUnfollowModal = true;
      }
    },
    /**
     * @function changeRememberFollowPatient -  Function to set remember patient follow service true or false based on user interaction
     * @param {boolean} - active
     */
    changeRememberFollowPatient(active) {
      this.setRememberPatientFollow(active);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox-group {
  display: flex;
  align-items: center;
}

.modal-checkbox {
  display: flex;
  vertical-align: middle;
  padding-right: 10px;
}
</style>
